import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Tools from './Tools';
import '../components/css/Chat.css';
import { AddLinkIcon, DeriveIcon, MessageIcon, BotIcon, UserIcon, ExecIcon, MinimizeMsgIcon, MaximizeMsgIcon } from './icons/svgIcons';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import TextareaAutosize from 'react-textarea-autosize';
import ModalWindow from './ModalWindow';

const ChatComponent = (props) => {

    //const [receivingChatCall, setReceivingChatCall] = useState(false);
    const [currentChatSessionId, setCurrentChatSessionId] = useState(null);
    const [currentConversation, setCurrentConversation] = useState([]);
    const [data, setData] = useState({});
    const [chatReponse, setChatReponse] = useState(null);
    const [finishedConversation, setFinishedConversation] = useState(false);
    const [disconnectedUser, setDisconnectedUser] = useState(false);
    const [availableChatExecutivesToDerive, setAvailableChatExecutivesToDerive] = useState([]);
    const [showHyperlink, setShowHyperlink] = useState(false);
    const [buttonFinishClicked, setButtonFinishClicked] = useState(false);
    const [htmlAttachedImage, setHtmlAttachedImage] = useState(null);

    const [overflowedTextarea, setOverflowedTextarea] = useState(false);
    const [textAreaPreviousHeight, setTextAreaPreviousHeight] = useState('55px');
    const [textAreaExpanded, setTextAreaExpanded] = useState(false);
    const [defaultMessage, setDefaultMessage] = useState(null);

    const myRef = useRef(null);

    //const chatBeep = require("./ui/chatBeep.mp3"); 

    useEffect(() => {
        const socket = Tools.currentSocketConnection;
        // socket.on("chatCall", data => {
        //     console.log("LLAMADA DE CHAT:", data);
        //     setReceivingChatCall(true);
        //     setCurrentChatSessionId(data.sessionId);
        // });

        setCurrentChatSessionId(props.sessionId);
        //connectToConversation(props.sessionId);
        getChatConversation(props.sessionId); 

        socket.on("chatAnswerFromUser", data => {
            setChatReponse(data);
        });

        socket.on("disconnectedUser", data => {
            setDisconnectedUser(true);
        });

        // socket.on("chatCall", data => {
        //     let audioBeep = new Audio(chatBeep);
        //     audioBeep.play();
        // });


        //set previous unsent messages
        let unsentMessages = JSON.parse(sessionStorage.getItem('unsentMessages') ?? '[]');
        let previousUnsentMessage = unsentMessages.find((msg) => msg.sessionId === props.sessionId);
        if (previousUnsentMessage && previousUnsentMessage!=='') {
            setDefaultMessage(previousUnsentMessage.msg);
        }
        
    }, []);

    useEffect(() => {
        if (chatReponse) {
            if(chatReponse.sessionId===currentChatSessionId){
                addResponse(chatReponse); 
            }
        }
    }, [chatReponse]);

    useEffect(() => {
        if (disconnectedUser) { finishConversation('disconnectedUser'); }
    }, [disconnectedUser]);

    //save unsent messages
    useEffect(() => {
        if (data.message && data.message!=='') { 
            let unsentMessages = JSON.parse(sessionStorage.getItem('unsentMessages')??'[]');
            let currentUnsentMessage=unsentMessages.find((msg) => msg.sessionId === currentChatSessionId);
            
            if (!currentUnsentMessage){
                currentUnsentMessage={}
                currentUnsentMessage.sessionId = currentChatSessionId;
                currentUnsentMessage.msg = data.message;
                unsentMessages.push(currentUnsentMessage);
                sessionStorage.setItem('unsentMessages', JSON.stringify(unsentMessages));
            } else {
                currentUnsentMessage.msg = data.message;
                sessionStorage.setItem('unsentMessages', JSON.stringify(unsentMessages));
            }
        } else {
            let unsentMessages = JSON.parse(sessionStorage.getItem('unsentMessages') ?? '[]');
            let currentUnsentMessage = unsentMessages.find((msg) => msg.sessionId === currentChatSessionId);
            if (currentUnsentMessage) {
                currentUnsentMessage.msg = '';
                sessionStorage.setItem('unsentMessages', JSON.stringify(unsentMessages));
            }
        }
    }, [data]);

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (event.target.value.trim() !== '') {
                event.preventDefault();
                addNewMessage(event.target.value);
                event.target.value = '';
                setData({ ...data, ['message']: '' })
            }
        }
    }

    const handleMaximize=(heightInPx, props) =>{
        if(heightInPx > 55) {
            setOverflowedTextarea(true);
            setTextAreaPreviousHeight(`${heightInPx}px`);
            setTextAreaExpanded(true);
        } else {
            setOverflowedTextarea(false);
            setTextAreaPreviousHeight(`55px`);
            setTextAreaExpanded(false);
        }
    }

    const restoreTextAreaHeight=()=>{
        myRef.current.style.height = textAreaPreviousHeight;
        setTextAreaExpanded(true);
    }

    const collapseTextarea=()=>{
        myRef.current.style.height="55px";
        setTextAreaExpanded(false);
    }

    const getChatConversation = (chatSessionId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatConversation`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { sessionId: chatSessionId }
        };
        axios(options).then(response => {
            setCurrentConversation(response.data.conversation);
        })
        .catch((error) => {
            console.log("Error:", error.message);
            //setError(error.message);
        });
    }

    const addNewMessage = async (message) => {
        let messageStatus=await sendExecutiveResponse(message);
        let fullMessage = { owner: 'exec', message: message, date: new Date(), delivered: messageStatus.delivered }
        let currentMessagesList = [...currentConversation];
        currentMessagesList.push(fullMessage);
        setCurrentConversation(currentMessagesList);
        props.cleanInactivityMark(props.sessionId);
    }

    const sendMessage = () => {
        if (myRef.current.value !== '') {
            addNewMessage(myRef.current.value);
            myRef.current.value = '';
        }
    }

    const addResponse = (response) => {
        let currentMessagesList = [...currentConversation];
        currentMessagesList.push(response);
        setCurrentConversation(currentMessagesList);
        //scrollToBottom();
    }

    const sendExecutiveResponse = (response) => {
        let promiseExecutiveResponse = new Promise((resolve, reject) => {
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/chatExecutiveAnswer`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: { sessionId: currentChatSessionId, response: response}
            };

            axios(options).then(response => {
                if (response.status === 200) {
                    //console.log('response.data:', response.data);
                    resolve(response.data);
                } else {
                    reject("error")
                }
            }).catch(error =>{
                console.log('error (sendExecutiveResponse):', error);
                reject("error")
            })
        });

        return promiseExecutiveResponse;
    }

    const finishConversation =(reason)=>{
        setButtonFinishClicked(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/finishConversation`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { sessionId: currentChatSessionId }
        };
        axios(options).then(response => {
            if(response.data.finished){
                setFinishedConversation(true); 
                
                if (reason ==='executiveFinishConversation'){
                    addAlert("Esta conversación ha finalizado. Esta ventana se cerrará dentro de 10 segundos")
                } else if (reason === 'disconnectedUser') {
                    addAlert("El usuario ha abandonado la conversación. Esta ventana se cerrará dentro de 10 segundos")
                }

                //props.removeChatSessionFn(currentChatSessionId); //remove from sidebar and session

                //close chat window
                setTimeout(() => {
                    //reset
                    setCurrentChatSessionId(null)
                    setCurrentConversation([]);
                    setDisconnectedUser(false);
                    setFinishedConversation(false);

                    //setTimeout(() => {
                        props.removeChatSessionFn(currentChatSessionId); //remove from sidebar and session
                   // }, 2000); 


                    //remove unset messages
                    let unsentMessages = JSON.parse(sessionStorage.getItem('unsentMessages') ?? '[]');
                    let indexUnsentMsg = unsentMessages.findIndex((msg) => msg.sessionId === currentChatSessionId);
                    if (indexUnsentMsg!== -1) {
                        unsentMessages.splice(indexUnsentMsg, 1);
                        sessionStorage.setItem('unsentMessages', JSON.stringify(unsentMessages));
                    }

                }, 0); 

            }
        })
        .catch((error) => {
            console.log("Error:", error.message);
            //setError(error.message);
        });
    }

    const getAvailableChatExecutivesToDerive=()=>{
        setAvailableChatExecutivesToDerive([]);//reset
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/availableChatExecutivesToDerive`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setAvailableChatExecutivesToDerive(response.data.availableChatExecutives);
        })
        .catch((error) => {
            console.log("Error:", error.message);
            //setError(error.message);
        });
    }

    const deriveCurrentChatTo=(extension)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/deriveCurrentChatToExcecutive`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: { extensionToDerive: extension, sessionId: currentChatSessionId }
        };

        axios(options).then(response => {
            if (response.status === 200) {
                props.removeChatSessionFn(currentChatSessionId);
            }
        }).catch((error) => {
            console.log("Error:", error.message);
        });
    }

    const addAlert=(message)=>{
        let currentMessagesList = [...currentConversation];
        currentMessagesList.push({ owner: 'system', message: message, alertType:"info"});
        setCurrentConversation(currentMessagesList);
        // scrollToBottom();
    }

    const addHyperlinkToConvesation=()=>{
        setShowHyperlink(true);
    }
    const insertHyperlinkToConvesation=()=>{
        myRef.current.value = `${myRef.current.value} <a href="${data.hiperlink}" target="_blank">${data.hiperlink}</a>`;
        myRef.current.focus();
        setShowHyperlink(false);
    }
    const cancelAddHyperlinkToConvesation =()=>{
        setShowHyperlink(false);
        myRef.current.focus();
    }

    const addCustomMessage=(messageKey)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let customMessage='';
        switch (messageKey) {
            case 'greeting':
                customMessage = `Hola, mi nombre es ${currentSessionData.name} y estoy aquí para resolver sus consultas`
                break;
            case 'waitOnline':
                customMessage = `Por favor espere un momento mientras trabajo en su consulta, en breve me pondré en contacto con usted para entregarle más información.`
                break;
            case 'stillWorking':
                customMessage = `Gracias por su paciencia. Sigo trabajando en su consulta, en breve me pondré en contacto con usted para entregarle más información.`
                break;
            case 'thankyouForYourPatience':
                customMessage = `Gracias por su paciencia, he resuelto su consulta `
                break;
            case 'moreInfo':
                customMessage = `Necesito más información para dar respuesta a su consulta`
                break;
            // case 'impatient':
            //     customMessage = `He recibido su solicitud y lamento la demora de su respuesta. Le comento que sigo trabajando en su consulta, de antemano agradezco su comprensión.`
                break;
            case 'more':
                customMessage = `¿Hay algo más en que le pueda ayudar?`
                break;
            case 'bye':
                customMessage = `Gracias por comunicarse con nosotros, si lo requiere nuevamente, no dude en contactarnos`
                break;
            default:
                customMessage='';
                break;
        }
        myRef.current.value = customMessage;
        myRef.current.focus();
    }

    const scrollToBottom = () => {
        setTimeout(() => {
            let cc = document.querySelector('.chatContainer');
            cc.scrollTo(0, cc.scrollHeight);
        }, 200);
    }

    const selectImage = (event) => {
        renderImage(event.target.files[0]);
    }

    function renderImage(file) {
        const { name: fileName, size: fileSize } = file;
        if (fileSize <= 5242880) { //5MB
            var reader = new FileReader();

            reader.onload = function (event) {
                const imageBase64 = event.target.result;
                let currentMessagesList = [...currentConversation];
                let messageImage = { owner: 'user', contentType: 'imageUpload', message: `<img src='${imageBase64}'/><br/><span>(Imagen adjunta)</span><br/>`, date: new Date() }
                currentMessagesList.push(messageImage);
                setCurrentConversation(currentMessagesList);
                //getResponse(messageImage.message);
                addNewMessage(messageImage.message);
            }

            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(file);
        } else {
            alert('Por favor, seleccione una imagen con un tamaño inferior a 5 MB.');
        }
    }

    return (
        <div className="ChatComponent">

            {htmlAttachedImage ?(
                <ModalWindow className="imgPreview" closeMethod={() => { setHtmlAttachedImage(null)}}>
                    {ReactHtmlParser(htmlAttachedImage)}
                </ModalWindow>  
            ) : null}  

            {currentConversation.length>0?(
                <div className="chatWrapper">
                    <div className="chatHeader flex gap10">
                        <button className="withIcon" onClick={() => addHyperlinkToConvesation('executiveFinishConversation')}><AddLinkIcon/> Insertar Link</button>
                        {showHyperlink ? (
                            <div className='hiperlinkContainer'>
                                <input name="hiperlink" onChange={handleChange} />
                                <button onClick={insertHyperlinkToConvesation}>insertar</button>
                                <button onClick={cancelAddHyperlinkToConvesation}>cancelar</button>
                            </div>
                        ) : null}

                        <Menu menuButton={<MenuButton className="withIcon"><MessageIcon/> Mensajes predefinidos</MenuButton>} transition >
                            <MenuItem onClick={() => addCustomMessage('greeting')}>Saludo</MenuItem>
                            <MenuItem onClick={() => addCustomMessage('waitOnline')}>Espere un momento ...</MenuItem>
                            <MenuItem onClick={() => addCustomMessage('stillWorking')}>Sigo trabajando en su consulta ...</MenuItem>
                            <MenuItem onClick={() => addCustomMessage('thankyouForYourPatience')}>He resuelto su consulta</MenuItem>
                            <MenuItem onClick={() => addCustomMessage('moreInfo')}>Necesito más información</MenuItem>
                            {/* <MenuItem onClick={() => addCustomMessage('impatient')}>Lamento la demora ...</MenuItem> */}
                            <MenuItem onClick={() => addCustomMessage('more')}>¿Hay algo más en que le pueda ayudar?</MenuItem>
                            <MenuItem onClick={() => addCustomMessage('bye')}>Despedida</MenuItem>
                        </Menu>

                        <Menu menuButton={<MenuButton className="withIcon" onClick={getAvailableChatExecutivesToDerive}><DeriveIcon/> Derivar</MenuButton>} transition >
                            {availableChatExecutivesToDerive.length > 0 ? (
                                availableChatExecutivesToDerive.map((exec, index) => {
                                    return (
                                        exec.socketIsAlive?(
                                            <MenuItem onClick={() => deriveCurrentChatTo(exec.extension)}>{exec.name}</MenuItem>
                                        ) : (
                                            <MenuItem className='disabled'>{exec.name} (Inactivo)</MenuItem>
                                        )
                                    );
                                })
                            ) : 
                            <div className='unavailableExecutives'>No hay ejecutivos disponibles para derivar la conversación en este momento.</div>
                            }
                        </Menu>

                        <button className="withIcon" disabled={buttonFinishClicked} onClick={() => finishConversation('executiveFinishConversation')}>Finalizar</button>
                    </div>

                    <div className="chatContainer">
                        {currentConversation.map((message, index) => {
                        return (
                            <div key={index} className={(message.owner === 'bot' || message.owner === 'exec')? 'messageRow bot' : message.owner==='system'?'messageRow system '+message.alertType:'messageRow user'}>
                                {message.owner === 'system' || message.owner === 'exec' || message.owner === 'bot' ? (
                                    
                                    
                                    // <span className="message" onAnimationEnd={scrollToBottom}>
                                    //     {ReactHtmlParser(message.message)}
                                        
                                    //     {message.date ? (
                                    //         <span className='date'>{Tools.formatTimeCl(message.date)}</span>
                                    //     ) : null}

                                    //     {message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                    //     : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                    //     : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                    //     : null}
                                    // </span>



                                    !message.message.startsWith("<img")?(
                                        <span className={message.delivered ? 'message delivered' :'message notDelivered'} onAnimationEnd={scrollToBottom}>
                                        {ReactHtmlParser(message.message)}
                                        
                                        {message.date ? (
                                            <span className='date'>{Tools.formatTimeCl(message.date)}</span>
                                        ) : null}

                                        {message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                        : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                        : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                        : null}
                                    </span>
                                    ) : 
                                    (
                                        



                                            <span className={message.delivered ? 'message containsAttachedImage delivered' : 'message containsAttachedImage notDelivered'} onAnimationEnd={scrollToBottom}>
                                                
                                                    <a onClick={() => setHtmlAttachedImage(message.message)}>{ReactHtmlParser(message.message)}</a>
                                                

                                                
                                                    <span className='date'>{Tools.formatTimeCl(message.date)}</span>
                                                

                                                    {message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                                    : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                                    : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                                    : null}
                                            </span>










                                    )






                                ) : (
                                    <span className={!message.message.startsWith("<img") ? 'message' :'message containsAttachedImage'} onAnimationEnd={scrollToBottom}>
                                        {!message.message.startsWith("<img")?
                                            message.message
                                            :
                                            <a onClick={() => setHtmlAttachedImage(message.message)}>{ReactHtmlParser(message.message)}</a>
                                        }

                                        {message.date ? (
                                            <span className='date'>{Tools.formatTimeCl(message.date)}</span>
                                        ) : null}

                                        {message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                        : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                        : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                        : null}
                                    </span>
                                )}
                            </div>
                        );
                        })}
                    </div>

                    <div className="flex">
                        <div className={!finishedConversation ? 'messageBox' :'messageBox disabled'}>
                            {/* <input ref={myRef} disabled={finishedConversation} name="message" onChange={handleChange} onKeyDown={handleKeyDown} placeholder='Responde aquí...' autoComplete="off" /> */}
                            <TextareaAutosize ref={myRef} className='autoHeightTextarea' disabled={finishedConversation} name="message" defaultValue={defaultMessage} onChange={handleChange} onKeyDown={handleKeyDown} placeholder='Responde aquí...' autoComplete="off" onHeightChange={handleMaximize} />
                            
                            {overflowedTextarea && textAreaExpanded ? (<button className="minMaxTA" onClick={collapseTextarea}><MinimizeMsgIcon/></button>):null}
                            {overflowedTextarea && !textAreaExpanded ? (<button className="minMaxTA" onClick={restoreTextAreaHeight}><MaximizeMsgIcon/></button>):null}

                            <button className="sendButton" onClick={sendMessage} disabled={finishedConversation}><i></i></button>
                        </div> 

                        <button className='addImage'>
                            <input type="file" className='addImage' accept="image/*" onChange={selectImage} />
                        </button>
                    </div>



                </div>
            ):null}
        </div>
    );
}

export default ChatComponent;
